export const MOBILE_APP_LINKS = {
  GOOGLE_PLAY: 'https://stellarfi.sng.link/Atact/lirr?_ios_dl=dashboard&_android_dl=dash&_smtype=3',
  APP_STORE: 'https://stellarfi.sng.link/Ctact/85om?_dl=dashboard&_smtype=3',
}
